var $ = jQuery.noConflict();
function is_zoom()
{
    return space_product_image_zoom;
}
( function( $ ) {
    "use strict";

	$( document ).ready(function() {

		//Accordion mobile menu
		$('#mobile-menu ul li.has-sub').append('<span class="holder"></span>');
		$('body').on('click','.holder',function(){
			var element = $(this).closest('li');
			if (element.hasClass('open')) {
				element.removeClass('open');
				element.find('li').removeClass('open');
				element.find('ul').slideUp();
			}
			else {
				element.addClass('open');
				element.children('ul').slideDown();
				element.siblings('li').children('ul').slideUp();
				element.siblings('li').removeClass('open');
				element.siblings('li').find('li').removeClass('open');
				element.siblings('li').find('ul').slideUp();
			}
		});

        //Comment Validate
        $("#commentform").validate();



        $('body').on('click','.modal-content .main-image img',function(event){
            event.preventDefault();
        });

	});


} )( jQuery );
